import React from "react"
import { motion, useReducedMotion } from "framer-motion"
import LandingButton from "./LandingButton"
import LandingReveal from "./LandingReveal"

const LandingCtaSection: React.FC = () => {
  const prefersReducedMotion = useReducedMotion()

  return (
    <section className="relative overflow-hidden bg-[#00205c] px-4 py-12 md:px-8 md:py-14 lg:px-20">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_0%_50%,rgba(158,126,67,0.18),transparent_55%)]" />
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_100%_50%,rgba(46,119,255,0.12),transparent_50%)]" />

      {!prefersReducedMotion && (
        <motion.div
          className="pointer-events-none absolute -right-16 top-1/2 h-48 w-48 -translate-y-1/2 rounded-full bg-[#9e7e43]/15 blur-3xl"
          animate={{ scale: [1, 1.12, 1], opacity: [0.5, 0.75, 0.5] }}
          transition={{ duration: 7, repeat: Infinity, ease: "easeInOut" }}
        />
      )}

      <LandingReveal className="relative mx-auto flex max-w-5xl flex-col items-center justify-between gap-6 sm:flex-row sm:gap-10">
        <div className="flex flex-col gap-2 text-center sm:text-left">
          <p className="font-dm-sans text-xs font-semibold uppercase tracking-[0.22em] text-[#9e7e43]">
            You&apos;re invited
          </p>
          <h2 className="font-outfit text-2xl font-semibold tracking-tight text-white md:text-3xl">
            Join Us This Sunday
          </h2>
          <p className="max-w-md font-dm-sans text-sm leading-6 tracking-wide text-white/75 md:text-base">
            We&apos;d love to welcome you into a community where you can grow in faith and purpose.
          </p>
        </div>

        <LandingButton href="/#our-locations" className="shrink-0">
          Plan Your Visit
        </LandingButton>
      </LandingReveal>
    </section>
  )
}

export default LandingCtaSection
